import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-checkbox-renderer",
  imports: [CommonModule, MatCheckboxModule],
  template: `<mat-checkbox [checked]="isChecked" [disabled]="true" class="cell-checkbox"></mat-checkbox>`,
  styles: [`.cell-checkbox { pointer-events: none; }`],
})
export class CheckboxRendererComponent implements ICellRendererAngularComp {
  isChecked = false;

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.isChecked = !!params.value;
    return true;
  }
}
